'use strict';

var angular = require('angular');
var dependencies = ['restangular'];
module.exports = angular.module('AVRO.Fares.Common', dependencies).factory('FaresDataManagementFactory', require('./factories/FaresDataManagementFactory'));